import { Buffer } from "buffer";
export const decodeJwtToken = (jwtToken) => {
    const tokenParts = jwtToken?.split(".");
    if (tokenParts?.length !== 3) {
        return;
    }
    return JSON.parse(Buffer.from(tokenParts[1], "base64").toString("utf-8"));
};
//# sourceMappingURL=decodeJwtToken.js.map